import { render, staticRenderFns } from "./RecipientMedicalAttachments.vue?vue&type=template&id=153c3083"
import script from "./RecipientMedicalAttachments.vue?vue&type=script&lang=js"
export * from "./RecipientMedicalAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports